import React, { useState, useEffect } from 'react';
import config from '../config.json';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';

// API URL 설정
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// 연구 페이지 컴포넌트
function Researches() {
  const { isAdmin } = useAuth();
  const [researches, setResearches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 이미지 URL 처리 헬퍼 함수
  const getImageUrl = (imageLink) => {
    if (!imageLink) return '';
    // Base64 이미지인 경우 그대로 반환
    if (imageLink.startsWith('data:image')) return imageLink;
    // 일반 경로인 경우 전체 URL 조합
    return `${config.images.serverUrl}${config.images.basePath}${imageLink}`;
  };

  // 데이터 가져오기
  useEffect(() => {
    fetchResearches();
  }, []);

  const fetchResearches = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/researches`);
      const data = await response.json();

      if (data.success) {
        setResearches(data.data);
      } else {
        setError('Failed to load researches');
      }
    } catch (err) {
      console.error('Error fetching researches:', err);
      setError('Failed to connect to server');
    } finally {
      setLoading(false);
    }
  };

  // 로딩 중
  if (loading) {
    return (
      <div className="site-content" style={{ textAlign: 'center', padding: '50px' }}>
        <p>Loading researches...</p>
      </div>
    );
  }

  // 에러 발생
  if (error) {
    return (
      <div className="site-content" style={{ textAlign: 'center', padding: '50px' }}>
        <p style={{ color: 'red' }}>{error}</p>
        <button onClick={fetchResearches}>Retry</button>
      </div>
    );
  }

  return (
    <div className="site-content">
      {/* Register 버튼 - 관리자에게만 표시 */}
      {isAdmin && (
        <div style={{ textAlign: 'right', margin: '20px 0' }}>
          <Link to="/register-research" style={{
            display: 'inline-block',
            padding: '8px 20px',
            backgroundColor: '#222',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: '3px',
            fontSize: '14px',
            border: 'none'
          }}>
            Register a Research
          </Link>
        </div>
      )}

      {/* 연구 주제들 */}
      {researches.map((research, index) => (
        <div key={research.ID} style={{ marginBottom: '50px', paddingTop: index > 0 ? '1.5em' : '0' }}>
          {/* 제목과 Edit 버튼 */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
            <h2 style={{ fontSize: '1.625rem', fontWeight: 'bold', margin: 0, flex: 1 }}>
              {research.title}
            </h2>
            {isAdmin && (
              <Link 
                to={`/edit-research/${research.ID}`}
                style={{
                  padding: '6px 14px',
                  fontSize: '13px',
                  backgroundColor: '#0066cc',
                  color: '#fff',
                  textDecoration: 'none',
                  borderRadius: '3px',
                  whiteSpace: 'nowrap',
                  marginLeft: '15px'
                }}
              >
                Edit
              </Link>
            )}
          </div>

          {/* 이미지 */}
          {research.image_link && (
            <div style={{ textAlign: 'center', margin: '20px 0' }}>
              <img 
                src={getImageUrl(research.image_link)}
                alt={research.title}
                style={{ maxWidth: '100%', height: 'auto' }}
              />
            </div>
          )}

          {/* Bullet Points */}
          {research.bullets && research.bullets.length > 0 && (
            <ul style={{ lineHeight: '1.8', color: '#555' }}>
              {research.bullets.map((bullet, idx) => (
                <li key={idx} dangerouslySetInnerHTML={{ __html: bullet }} />
              ))}
            </ul>
          )}

          {/* 구분선 제거 */}
        </div>
      ))}

      {researches.length === 0 && (
        <p style={{ textAlign: 'center', color: '#666', marginTop: '50px' }}>
          No research topics found.
        </p>
      )}
    </div>
  );
}

export default Researches;
